export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";